/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Card2Inputs */

const en_dr_room_card2 = /** @type {(inputs: Dr_Room_Card2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp reminder 1 day before the appointment`)
};

const id_dr_room_card2 = /** @type {(inputs: Dr_Room_Card2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengingat WhatsApp H-1 sebelum jadwal`)
};

/**
* | output |
* | --- |
* | "WhatsApp reminder 1 day before the appointment" |
*
* @param {Dr_Room_Card2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_card2 = /** @type {((inputs?: Dr_Room_Card2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Card2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_card2(inputs)
	return en_dr_room_card2(inputs)
});